export default __webpack_public_path__ + "static/media/dezubic.8588fe50.png";